import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  GridCol,
  Group,
  Modal,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconBrandBootstrap,
  IconCheck,
  IconDoorEnter,
  IconDots,
  IconDownload,
  IconSearch,
  IconSection,
  IconTimeDuration15,
  IconTransferIn,
  IconTransferOut,
  IconTrash,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import * as xlsx from "xlsx";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useIsFirstRender, useMediaQuery } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconFilePlus, IconX } from "@tabler/icons-react";
import moment from "moment";
import { useNavigate } from "react-router";
import {
  _timerDelayClick,
  keySearchwip,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { SelectListItem } from "../../../model/SelectListItem";
import AccessoryView from "./AccessoryView";
import DetailWipView from "./DetailView";
import DeleteTicket from "./ModalDelete";

interface ProductionOrder {
  id: string;
  maLsx: string; // Mã lệnh sản xuất
  ngayDksx: string; // Ngày đăng ký sản xuất (ISO format)
  maSp: string; // Mã sản phẩm
  idLsx: number;
  tenSp: string; // Tên sản phẩm
  maCn: string; // Mã chi nhánh
  tenCn: string; // Tên chi nhánh
  attribute1: string | null; // Thông số 1 (có thể null)
  attribute12: string | null; // Thông số 12 (có thể null)
  slSx: number; // Số lượng sản xuất
  maPx: string | null; // Mã phiếu xuất (có thể null)
  ngayXuat: string | null; // Ngày xuất (có thể null)
  ngLpx: string | null; // Người lập phiếu xuất (có thể null)
  maKh: string; // Mã khách hàng
  tenKh: string; // Tên khách hàng
  trangThai: string | null; // Trạng thái (có thể null)
  attribute13: string | null;
  attribute14: string | null;
}

const MfgWip = () => {
  const navigate = useNavigate();
  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<ProductionOrder[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };
  const isSmallScreen = useMediaQuery("(max-width: 768px)");
  const [dataBranch, setDataBranch] = useState<SelectListItem[]>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    [],
  );
  const firstRender = useIsFirstRender();

  // const [typeKey, settypeKey] = useState<number | null>(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const [columnPinning, setColumnPinning] = useState<boolean | undefined>(true);
  const [search, setSearch] = useState({
    keySearch: "",
    FromDate: "",
    BranchId: "",
    ToDate: "",
    status: "",
  });

  const _searchJson = sessionStorage.getItem(keySearchwip)
    ? JSON.parse(sessionStorage.getItem(keySearchwip) ?? "")
    : null;

  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";

  const [searchReturn, setSearchReturn] = useState({
    ...search,
  });

  const [dataExportExcel, setDataExportExcel] = useState<any[]>([]);

  const statusAtt14 = [
    { label: "Tạo mới", value: "TAO_MOI" },
    {
      label: "Chưa nhập",
      value: "CHUA_NHAP",
    },
    {
      label: "Nhập hồi hoàn thành",
      value: "NHAP_HOI_HOAN_THANH",
    },
  ];

  const innitStateSearch = useMemo(
    () => ({
      BranchId:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.BranchId as string)
          : "",
      FromDate:
        firstRender && _searchJson && _searchJson.FromDate && checkedPinSearch
          ? new Date(_searchJson.FromDate)
          : null,
      ToDate:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        _searchJson.ToDate &&
        _searchJson.ToDate != null
          ? new Date(_searchJson.ToDate)
          : null,
      keySearch:
        checkedPinSearch && firstRender && _searchJson && checkedPinSearch
          ? _searchJson.KeySearch
          : "",
    }),
    [firstRender, _searchJson],
  );

  const form = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });

  const detailDataOut = (
    id: string | number,
    type: string | number | null,
    isLocked: boolean,
  ) => {
    navigate("/warehouse-config/detail-warehouse-out-ward", {
      state: { transactionCode: id, type: type, isLocked: isLocked },
    });
  };

  const detailDataOutWithSourceCode = (
    sourceCode: string,
    type: string | number | null,
    isLocked: boolean,
  ) => {
    navigate("/warehouse-config/detail-warehouse-out-ward", {
      state: { transactionCode: sourceCode, type: type, isLocked: isLocked },
    });
  };

  const detailDataIn = (
    id: string | number,
    type: string | number | null,
    isLocked: boolean,
  ) => {
    navigate("/warehouse-config/detail-warehouse-in-ward", {
      state: { transactionCode: id, sourceType: type, isLocked: isLocked },
    });
  };

  const detailDataInWithSourceCode = (
    sourceCode: string,
    type: string | number | null,
    isLocked: boolean,
  ) => {
    navigate("/warehouse-config/detail-warehouse-in-ward", {
      state: {
        transactionCode: sourceCode,
        sourceType: type,
        isLocked: isLocked,
      },
    });
  };

  const DeleteCancelOrder = (PIds: string) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Hủy đơn hàng!</Title>
        </>
      ),
      size: "auto",
      children: <DeleteTicket PIds={PIds} onSearch={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const openDeleteModal = (id: number) => () => {
    modals.open({
      title: <Title order={5}>Chi tiết lệnh sản xuất</Title>,
      size: "90%",
      children: <DetailWipView idItems={id} />,
    });
  };

  const openAccessory = (id: string) => () => {
    modals.open({
      title: <Title order={5}>Danh sách các linh kiện </Title>,
      size: "90%",
      children: <AccessoryView idItems={id} />,
    });
  };

  const handleCommandLSX = async (idCommand: string) => {
    try {
      const response = await repositoryPos.post(
        "/api/v1/TblMfgProductOrder/close",
        {
          id: idCommand,
        },
      );
      if (response && response.success) {
        await fetchData();
        NotificationExtension.Success("Đóng lệnh sản xuất thành công");
      }
    } catch (error) {
      console.log("error", error);
      NotificationExtension.Fails("Đóng lệnh sản xuất không thành công");
    } finally {
      modals.closeAll();
    }
  };
  const CloseCommandLSXModal = (idCommand: string) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Đóng lệnh sản xuất!</Title>
        </>
      ),
      size: "auto",
      children: (
        <>
          <Box size={"auto"}>
            <Text size="20px" mt={5}>
              Bạn có chắc chắn muốn đóng lệnh sản xuất này ?
            </Text>
            <Group justify="center" mt="lg">
              <Button
                type="button"
                color="gray"
                onClick={() => modals.closeAll()}
                leftSection={<IconX size={18} />}
              >
                Thoát
              </Button>
              <Button
                type="button"
                color="red"
                onClick={() => handleCommandLSX(idCommand)}
                leftSection={<IconCheck size={18} />}
              >
                Xác nhận
              </Button>
            </Group>
          </Box>
        </>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const columns = React.useMemo<MRT_ColumnDef<ProductionOrder>[]>(
    () => [
      {
        accessorKey: "maLsx",
        enableColumnActions: false,
        header: "Mã lệnh sản xuất",
        size: 150,
        Cell: ({ renderedCellValue, row }: any) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              style={{ cursor: "pointer" }}
              size="md"
              color={renderedCellValue === null ? "red" : green.base}
              onClick={openDeleteModal(row.original.idLsx)}
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "ngayDksx",
        enableColumnActions: false,
        size: 150,
        header: "Ngày đăng ký sx",
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue &&
              formatDateTransfer(renderedCellValue as string)}
          </>
        ),
      },
      {
        accessorKey: "maSp",
        enableColumnActions: false,
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue, row }: any) =>
          renderedCellValue === null ? null : (
            <Badge variant="light">{renderedCellValue}</Badge>
          ),
        size: 150,
      },
      {
        accessorKey: "tenSp",
        enableColumnActions: false,
        header: "Tên sản phẩm",
        size: 700,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maCn",
        enableColumnActions: false,
        header: "Mã chi nhánh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenCn",
        enableColumnActions: false,
        header: "Tên chi nhánh",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "slSx",
        enableColumnActions: false,
        header: "Số lượng YC sản xuất",
        Cell: ({ renderedCellValue }) => (
          <>{renderedCellValue === null ? 0 : renderedCellValue}</>
        ),
      },

      // {
      //   accessorKey: "transferQuantity",
      //   enableColumnActions: false,
      //   header: "Số lượng đã lắp ráp",
      //   size: 80,
      //   Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      // },
      {
        accessorKey: "attribute1",
        enableColumnActions: false,
        header: "Số lượng đã lắp ráp",
        Cell: ({ renderedCellValue }) => (
          <>{renderedCellValue === null ? 0 : renderedCellValue}</>
        ),
      },
      {
        accessorKey: "attribute12",
        enableColumnActions: false,
        header: "Số lượng nhập thành phẩm",
        size: 225,
        Cell: ({ renderedCellValue }) => (
          <>{renderedCellValue === null ? 0 : renderedCellValue}</>
        ),
      },
      {
        accessorKey: "khoXuatAsia",
        enableColumnActions: false,
        header: "Mã kho xuất Asia",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maPx",
        enableColumnActions: false,
        header: "Mã PX kho Asia",
        Cell: ({ cell, renderedCellValue }) => {
          const formattedValue = renderedCellValue
            ? renderedCellValue.toString().split(",").join(", ")
            : "";
          return (
            <Tooltip label={formattedValue}>
              <Box w={200}>
                <Text fw={600} size="sm" truncate="end">
                  {formattedValue}
                </Text>
              </Box>
            </Tooltip>
          );
        },
      },
      {
        accessorKey: "attribute8",
        enableColumnActions: false,
        header: "Mã Kho xuất ĐC",
        Cell: ({ cell, renderedCellValue }) => {
          const formattedValue = renderedCellValue
            ? renderedCellValue.toString().split(",").join(", ")
            : "";
          return (
            <Tooltip label={formattedValue}>
              <Box w={200}>
                <Text fw={600} size="sm" truncate="end">
                  {formattedValue}
                </Text>
              </Box>
            </Tooltip>
          );
        },
      },
      {
        accessorKey: "attribute3",
        enableColumnActions: false,
        header: "Mã phiếu xuất ĐC",
        Cell: ({ cell, renderedCellValue }) => {
          const [opened, setOpened] = useState(false);
          const [searchTerm, setSearchTerm] = useState("");
          const values = renderedCellValue
            ? renderedCellValue
                .toString()
                .split(",")
                .map((value) => value.trim())
            : [];

          const filteredValues = values.filter((value) =>
            value.toLowerCase().includes(searchTerm.toLowerCase()),
          );

          return (
            <>
              <Box display="flex">
                <Flex align="center" variant="filled" gap={5}>
                  {values.slice(0, 1).map((value, index) => (
                    <Badge
                      key={index}
                      size="lg"
                      style={{ cursor: "pointer" }}
                      onClick={async () => {
                        detailDataOut(
                          value,
                          "XUAT_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT",
                          true, // status === "LOCK"
                        );
                      }}
                      variant="default"
                      fw={600}
                    >
                      {value}
                    </Badge>
                  ))}
                  {values.length > 1 && (
                    <ActionIcon
                      onClick={() => setOpened(true)}
                      color="blue"
                      radius="xl"
                      variant="light"
                      aria-label="Settings"
                    >
                      <IconDots size="1.2rem" />
                    </ActionIcon>
                  )}
                </Flex>
              </Box>
              <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                size="550"
                title={<Title order={5}>Danh sách mã phiếu</Title>}
              >
                <TextInput
                  placeholder="Tìm kiếm mã phiếu..."
                  value={searchTerm}
                  radius="xl"
                  mt={10}
                  leftSection={<IconSearch size="1rem" />}
                  onChange={(event) => setSearchTerm(event.currentTarget.value)}
                  mb={10}
                  w={170}
                />
                <Flex gap={10} mt={20} wrap="wrap">
                  {filteredValues.map((value, index) => (
                    <Badge
                      size="lg"
                      key={index}
                      style={{ cursor: "pointer" }}
                      onClick={async () => {
                        detailDataOut(
                          value,
                          "XUAT_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT",
                          true,
                        );
                        setOpened(false);
                      }}
                      variant="default"
                      fw={600}
                    >
                      {value}
                    </Badge>
                  ))}
                  {filteredValues.length === 0 && (
                    <Text>Không tìm thấy kết quả</Text>
                  )}
                </Flex>
              </Modal>
            </>
          );
        },
      },
      {
        accessorKey: "attribute9",
        enableColumnActions: false,
        header: "Mã kho nhập ĐC",
        Cell: ({ cell, renderedCellValue }) => {
          const formattedValue = renderedCellValue
            ? renderedCellValue.toString().split(",").join(", ")
            : "";
          return (
            <Tooltip label={formattedValue}>
              <Box w={200}>
                <Text fw={600} size="sm" truncate="end">
                  {formattedValue}
                </Text>
              </Box>
            </Tooltip>
          );
        },
      },
      {
        accessorKey: "attribute4",
        enableColumnActions: false,
        header: "Mã phiếu nhập ĐC",
        Cell: ({ cell, renderedCellValue }) => {
          const [opened, setOpened] = useState(false);
          const [searchTerm, setSearchTerm] = useState("");
          const values = renderedCellValue
            ? renderedCellValue
                .toString()
                .split(",")
                .map((value) => value.trim())
            : [];

          const filteredValues = values.filter((value) =>
            value.toLowerCase().includes(searchTerm.toLowerCase()),
          );

          return (
            <>
              <Box display="flex">
                <Flex align="center" variant="filled" gap={5}>
                  {values.slice(0, 1).map((value, index) => (
                    <Badge
                      key={index}
                      size="lg"
                      style={{ cursor: "pointer" }}
                      onClick={async () => {
                        detailDataIn(
                          value,
                          "NHAP_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT",
                          true, // status === "LOCK"
                        );
                      }}
                      variant="default"
                      fw={600}
                    >
                      {value}
                    </Badge>
                  ))}
                  {values.length > 1 && (
                    <ActionIcon
                      onClick={() => setOpened(true)}
                      color="blue"
                      radius="xl"
                      variant="light"
                      aria-label="Settings"
                    >
                      <IconDots size="1.2rem" />
                    </ActionIcon>
                  )}
                </Flex>
              </Box>
              <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                size="550"
                title={<Title order={5}>Danh sách mã phiếu</Title>}
              >
                <TextInput
                  placeholder="Tìm kiếm mã phiếu..."
                  value={searchTerm}
                  radius="xl"
                  mt={10}
                  leftSection={<IconSearch size="1rem" />}
                  onChange={(event) => setSearchTerm(event.currentTarget.value)}
                  mb={10}
                  w={170}
                />
                <Flex gap={10} mt={20} wrap="wrap">
                  {filteredValues.map((value, index) => (
                    <Badge
                      size="lg"
                      key={index}
                      style={{ cursor: "pointer" }}
                      onClick={async () => {
                        detailDataIn(
                          value,
                          "NHAP_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT",
                          true,
                        );
                        setOpened(false);
                      }}
                      variant="default"
                      fw={600}
                    >
                      {value}
                    </Badge>
                  ))}
                  {filteredValues.length === 0 && (
                    <Text>Không tìm thấy kết quả</Text>
                  )}
                </Flex>
              </Modal>
            </>
          );
        },
      },
      {
        accessorKey: "attribute5",
        enableColumnActions: false,
        header: "Mã phiếu xuất linh kiện",
        size: 200,
        Cell: ({ cell, renderedCellValue }) => {
          const [opened, setOpened] = useState(false);
          const [searchTerm, setSearchTerm] = useState("");
          const values = renderedCellValue
            ? renderedCellValue
                .toString()
                .split(",")
                .map((value) => value.trim())
            : [];

          const filteredValues = values.filter((value) =>
            value.toLowerCase().includes(searchTerm.toLowerCase()),
          );

          return (
            <>
              <Box display="flex">
                <Flex align="center" variant="filled" gap={5}>
                  {values.slice(0, 1).map((value, index) => (
                    <Badge
                      key={index}
                      size="lg"
                      style={{ cursor: "pointer" }}
                      onClick={async () => {
                        detailDataOut(
                          value,
                          "XUAT_LINH_KIEN_SAN_XUAT",
                          true, // status === "LOCK"
                        );
                      }}
                      variant="default"
                      fw={600}
                    >
                      {value}
                    </Badge>
                  ))}
                  {values.length > 1 && (
                    <ActionIcon
                      onClick={() => setOpened(true)}
                      color="blue"
                      radius="xl"
                      variant="light"
                      aria-label="Settings"
                    >
                      <IconDots size="1.2rem" />
                    </ActionIcon>
                  )}
                </Flex>
              </Box>
              <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                size="550"
                title={<Title order={5}>Danh sách mã phiếu </Title>}
              >
                <TextInput
                  placeholder="Tìm kiếm mã phiếu..."
                  value={searchTerm}
                  radius="xl"
                  mt={10}
                  leftSection={<IconSearch size="1rem" />}
                  onChange={(event) => setSearchTerm(event.currentTarget.value)}
                  mb={10}
                  w={170}
                />
                <Flex gap={10} mt={20} wrap="wrap">
                  {filteredValues.map((value, index) => (
                    <Badge
                      size="lg"
                      key={index}
                      style={{ cursor: "pointer" }}
                      onClick={async () => {
                        detailDataOut(value, "XUAT_LINH_KIEN_SAN_XUAT", true);
                        setOpened(false);
                      }}
                      variant="default"
                      fw={600}
                    >
                      {value}
                    </Badge>
                  ))}
                  {filteredValues.length === 0 && (
                    <Text>Không tìm thấy kết quả</Text>
                  )}
                </Flex>
              </Modal>
            </>
          );
        },
      },
      {
        accessorKey: "attribute11",
        enableColumnActions: false,
        header: "Mã Kho nhập TP",
        Cell: ({ cell, renderedCellValue }) => {
          const formattedValue = renderedCellValue
            ? renderedCellValue.toString().split(",").join(", ")
            : "";
          return (
            <Tooltip label={formattedValue}>
              <Box w={100}>
                <Text fw={600} size="sm" truncate="end">
                  {formattedValue}
                </Text>
              </Box>
            </Tooltip>
          );
        },
      },
      {
        accessorKey: "attribute6",
        enableColumnActions: false,
        header: "Mã phiếu nhập TP",
        Cell: ({ cell, renderedCellValue }) => {
          const [opened, setOpened] = useState(false);
          const [searchTerm, setSearchTerm] = useState("");
          const values = renderedCellValue
            ? renderedCellValue
                .toString()
                .split(",")
                .map((value) => value.trim())
            : [];

          const filteredValues = values.filter((value) =>
            value.toLowerCase().includes(searchTerm.toLowerCase()),
          );

          return (
            <>
              <Box display="flex">
                <Flex align="center" variant="filled" gap={5}>
                  {values.slice(0, 1).map((value, index) => (
                    <Badge
                      key={index}
                      size="lg"
                      style={{ cursor: "pointer" }}
                      onClick={async () => {
                        detailDataIn(
                          value,
                          "NHAP_THANH_PHAM_SAN_XUAT",
                          true, // status === "LOCK"
                        );
                      }}
                      variant="default"
                      fw={600}
                    >
                      {value}
                    </Badge>
                  ))}
                  {values.length > 1 && (
                    <ActionIcon
                      onClick={() => setOpened(true)}
                      color="blue"
                      radius="xl"
                      variant="light"
                      aria-label="Settings"
                    >
                      <IconDots size="1.2rem" />
                    </ActionIcon>
                  )}
                </Flex>
              </Box>
              <Modal
                opened={opened}
                onClose={() => setOpened(false)}
                size="550"
                title={<Title order={5}>Danh sách mã phiếu </Title>}
              >
                <TextInput
                  placeholder="Tìm kiếm mã phiếu..."
                  value={searchTerm}
                  radius="xl"
                  mt={10}
                  leftSection={<IconSearch size="1rem" />}
                  onChange={(event) => setSearchTerm(event.currentTarget.value)}
                  mb={10}
                  w={170}
                />
                <Flex gap={10} mt={20} wrap="wrap">
                  {filteredValues.map((value, index) => (
                    <Badge
                      size="lg"
                      key={index}
                      style={{ cursor: "pointer" }}
                      onClick={async () => {
                        detailDataIn(value, "NHAP_THANH_PHAM_SAN_XUAT", true);
                        setOpened(false);
                      }}
                      variant="default"
                      fw={600}
                    >
                      {value}
                    </Badge>
                  ))}
                  {filteredValues.length === 0 && (
                    <Text>Không tìm thấy kết quả</Text>
                  )}
                </Flex>
              </Modal>
            </>
          );
        },
      },
      {
        accessorKey: "attribute13",
        header: "Phiếu nhập hồi linh kiện Asia",
        size: 250,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge color="green" variant="dot" radius={"sm"} size="md">
              {renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "attribute14",
        header: "Trạng thái phiếu nhập hồi linh kiện",
        size: 275,
        Cell: ({ renderedCellValue }) => (
          <>
            {getValueById(String(renderedCellValue), statusAtt14, "label") ||
              renderedCellValue}
          </>
        ),
      },
      {
        accessorKey: "attribute15",
        header: "Phiếu xuất kho hồi linh kiện",
        size: 250,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge
              color="green"
              variant="dot"
              radius={"sm"}
              size="md"
              onDoubleClick={() =>
                detailDataOutWithSourceCode(
                  String(renderedCellValue),
                  "XUAT_HOI_LINH_KIEN_SAN_XUAT",
                  true,
                )
              }
            >
              {renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "attribute16",
        header: "Phiếu nhập kho hồi linh kiện",
        size: 250,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge
              color="green"
              variant="dot"
              radius={"sm"}
              size="md"
              onDoubleClick={() =>
                detailDataInWithSourceCode(
                  String(renderedCellValue),
                  "NHAP_HOI_LINH_KIEN_SAN_XUAT",
                  true,
                )
              }
            >
              {renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      // {
      //   accessorKey: "makhach",
      //   enableColumnActions: false,
      //   header: "",
      //   Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      // },
      {
        accessorKey: "ngayXuat",
        enableColumnActions: false,
        header: "Ngày xuất",
        Cell: ({ renderedCellValue }) => (
          <>
            {renderedCellValue &&
              formatDateTransfer(renderedCellValue as string)}
          </>
        ),
      },
      {
        accessorKey: "ngLpx",
        enableColumnActions: false,
        header: "Người lập PX",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "maKh",
        enableColumnActions: false,
        header: "Mã khách",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenKh",
        enableColumnActions: false,
        header: "Tên khách",
        size: 500,
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "trangThai",
        enableColumnActions: false,
        header: "Trạng thái",
        Cell: ({ renderedCellValue }) => {
          const displayValue = (() => {
            switch (renderedCellValue) {
              case "DIEU_CHUYEN_HOAN_THANH":
                return "Điều chuyển hoàn thành";
              case "DANG_LAP_RAP":
                return "Đang lắp ráp";
              case "XUAT_DIEU_CHUYEN":
                return "Xuất điều chuyển";
              case "DANG_XUAT_LINH_KIEN":
                return "Đang xuất linh kiện";
              case "HOAN_THANH":
                return "Hoàn thành";
              case "DA_XUAT_LINH_KIEN":
                return "Đã xuất linh kiện";
              case "TAO_MOI":
                return "Tạo mới";
              case "NHAP_DIEU_CHUYEN":
                return "Nhập điều chuyển";
              case "DONG":
                return "Đã đóng lệnh";
              case "HOAN_THANH_MOT_PHAN":
                return "Hoàn thành một phần";
              case "HUY":
                return "Hủy";
              default:
                return null;
            }
          })();

          const badgeColor = (() => {
            switch (displayValue) {
              case "Điều chuyển hoàn thành":
                return "blue";
              case "Đang lắp ráp":
                return "#15aabf";
              case "Xuất điều chuyển":
                return "orange";
              case "Đang xuất linh kiện":
                return "yellow";
              case "Đã xuất linh kiện":
                return "blue";
              case "Tạo mới":
                return "gray";
              case "Nhập điều chuyển":
                return "violet";
              case "Hoàn thành":
                return "green";
              case "Đã đóng lệnh":
                return "red";
              case "Hoàn thành một phần":
                return "purple";
              case "Hủy":
                return "red";
              default:
                return "gray";
            }
          })();

          return (
            <>
              {displayValue === null ? null : (
                <Badge
                  styles={(theme) => ({
                    root: {
                      border: `1px solid ${badgeColor}`,
                    },
                  })}
                  variant="light"
                  color={badgeColor}
                >
                  {displayValue}
                </Badge>
              )}
            </>
          );
        },
      },
      {
        accessorKey: "action",
        enableColumnActions: false,
        enableResizing: false,
        header: "Thao tác",
        size: 275,
        Cell: ({ row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
            }}
          >
            {/* <Tooltip label="Chi tiết">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="cyan"
                onClick={openDeleteModal(row.original.idLsx)}
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip> */}
            <Tooltip label="Đổi linh kiện">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="#a9e34b"
                bd="1px solid #a9e34b"
                onClick={openAccessory(row.original.maLsx)}
              >
                <IconSection stroke={2} color="#000" size={20} />
              </ActionIcon>
            </Tooltip>
            <Divider size="sm" orientation="vertical" />
            <Tooltip
              label={
                !row.original.maPx
                  ? "Chưa có mã phiếu xuất kho"
                  : "Xuất điều chuyển linh kiện sản xuất"
              }
            >
              <ActionIcon
                variant="light"
                disabled={
                  !row.original.maPx ||
                  row.original.trangThai === "NHAP_DIEU_CHUYEN" ||
                  row.original.trangThai === "DANG_XUAT_LINH_KIEN" ||
                  row.original.trangThai === "DANG_LAP_RAP" ||
                  row.original.trangThai === "DIEU_CHUYEN_HOAN_THANH" ||
                  row.original.trangThai === "DA_XUAT_LINH_KIEN" ||
                  row.original.trangThai === "HOAN_THANH" ||
                  row.original.trangThai === "HUY"
                }
                onClick={() => {
                  if (row.original.maPx) {
                    createOutward(row?.original?.maPx);
                  } else {
                    NotificationExtension.Fails("Chưa có mã phiếu xuất kho");
                  }
                }}
              >
                <IconFilePlus size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xuất linh kiện sản xuất">
              <ActionIcon
                variant="light"
                color="orange"
                disabled={
                  !row.original.maPx ||
                  row.original.trangThai === "XUAT_DIEU_CHUYEN" ||
                  row.original.trangThai === "DA_XUAT_LINH_KIEN" ||
                  row.original.trangThai === "HOAN_THANH" ||
                  row.original.attribute14 === "NHAP_HOI_HOAN_THANH" ||
                  row.original.trangThai === "HUY"
                }
                onClick={() => {
                  if (
                    row.original.maLsx !== null &&
                    row.original.maLsx !== undefined
                  ) {
                    createOutwarDaccessory(row.original.maLsx);
                  }
                }}
              >
                <IconTransferOut size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label={"Nhập thành phẩm"}>
              <ActionIcon
                variant="light"
                color="green"
                disabled={
                  !row.original.maLsx ||
                  !row.original.maPx ||
                  row.original.trangThai === "XUAT_DIEU_CHUYEN" ||
                  row.original.trangThai === "NHAP_DIEU_CHUYEN" ||
                  row.original.trangThai === "HOAN_THANH" ||
                  row.original.trangThai === "DIEU_CHUYEN_HOAN_THANH" ||
                  String(row?.original?.attribute1) ===
                    String(row.original.attribute12)
                }
                onClick={() => {
                  if (row.original.maLsx) {
                    createInward(row?.original?.maLsx);
                  } else {
                    NotificationExtension.Fails("Chưa có mã lệnh sản xuất");
                  }
                }}
              >
                <IconTransferIn size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            {/* <Tooltip label={"Đóng lệnh"}>
              <ActionIcon
                variant="light"
                color="red"
                disabled={
                  row.original.trangThai === "HOAN_THANH" ||
                  row.original.trangThai === "DONG" ||
                  row.original.trangThai === "XUAT_DIEU_CHUYEN" ||
                  row.original.trangThai === "TAO_MOI"
                }
                onClick={() => {
                  CloseCommandLSXModal(row.original.id);
                }}
              >
                <IconLock size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip> */}
            <Tooltip label="Nhập hồi linh kiện">
              <ActionIcon
                variant="light"
                disabled={
                  !row.original.attribute13 ||
                  !row.original.attribute14 ||
                  (row.original.attribute14 !== "CHUA_NHAP" &&
                    row.original.attribute14 !== "TAO_MOI") ||
                  (row.original.trangThai !== "DIEU_CHUYEN_HOAN_THANH" &&
                    row.original.trangThai !== "DANG_LAP_RAP")
                }
                color="blue"
                onClick={() => {
                  navigate("/warehouse-config/create-warehouse-out-ward", {
                    state: {
                      sourceCode: row.original.attribute13,
                      sourceType: "XUAT_HOI_LINH_KIEN_SAN_XUAT",
                    },
                  });
                }}
              >
                <IconDoorEnter size={20} stroke={2} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label={"Xóa phiếu"}>
              <ActionIcon
                variant="light"
                disabled={
                  !(
                    row.original.trangThai === "XUAT_DIEU_CHUYEN" ||
                    row.original.trangThai === "TAO_MOI"
                  )
                }
                aria-label="Request"
                color="red"
                onClick={() => {
                  DeleteCancelOrder(row.original?.id);
                }}
              >
                <IconTrash size={20} stroke={2} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [statusAtt14],
  );

  const detailItem = (id: string | number) => {
    navigate("/warehouse-config/detail-wip", { state: { id } });
  };
  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };
  // const handleExport = async () => {
  //   let queryParams = {
  //     Skip:
  //       firstRender && _searchJson
  //         ? _searchJson.Skip
  //         : pagination.pageIndex * pagination.pageSize,
  //     Take: firstRender && _searchJson ? _searchJson.Take : pagination.pageSize,
  //   } as any;

  //   try {
  //     const search = form.getValues();
  //     queryParams = {
  //       ...queryParams,
  //       // Skip: pagination.pageIndex * pagination.pageSize,
  //       // Take: pagination.pageSize,
  //       BranchId: search.BranchId?.toString(),
  //       FromDate: search.FromDate
  //         ? moment(search?.FromDate).format("M/D/YYYY")
  //         : "",
  //       ToDate: search.ToDate
  //         ? moment(search?.ToDate).format("M/D/YYYY")
  //         : "",
  //       KeySearch: search.keySearch?.toString(),
  //     };

  //     let sortingQuery = "";
  //     if (sorting && sorting.length > 0) {
  //       const { id, desc } = sorting[0] || {};
  //       if (id) {
  //         sortingQuery = `&sort=${encodeURIComponent(id)}&isOrder=${desc}`;
  //       }
  //     }

  //     const urls =
  //       Object.entries(queryParams)
  //         .reduce((acc, [key, value]) => {
  //           if (
  //             value !== undefined &&
  //             value !== "" &&
  //             value !== null &&
  //             typeof value !== "object"
  //           ) {
  //             return `${acc}&${key}=${encodeURIComponent(String(value))}`;
  //           }
  //           return acc;
  //         }, "/api/v1/ExportExcel/export-lenh-san-xuat?")
  //         .replace("?&", "?") + sortingQuery;

  //     const _url = BASE_API_MDM + urls;
  //     const token = localStorage.getItem("token");

  //     const response = await fetch(_url, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/vnd.ms-excel",
  //         Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
  //       },
  //     });

  //     if (!response.ok) {
  //       throw new Error("Failed to download file");
  //     }
  //     const blob = await response.blob();
  //     const urlss = window.URL.createObjectURL(blob);
  //     const _name = new Date().toISOString().slice(0, 10);
  //     let filename = "bao_cao_lenh_san_xuat_" + _name + ".xlsx";
  //     const link = document.createElement("a");
  //     link.href = urlss;
  //     link.download = filename;
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //     window.URL.revokeObjectURL(queryParams);
  //   } catch (error) {
  //     console.error("Error downloading file:", error);
  //   }
  // };

  const handleExport = () => {
    try {
      // Tạo ánh xạ tiêu đề từ columns
      const columnHeaders = columns.reduce(
        (acc, column) => {
          if (column.accessorKey && column.header) {
            acc[column.accessorKey] = column.header; // Tạo ánh xạ giữa accessorKey và header
          }
          return acc;
        },
        {} as Record<string, string>,
      );

      // Lấy thứ tự cột từ columns
      const columnOrder = columns
        .filter((column) => column.accessorKey) // Chỉ lấy các cột có accessorKey
        .map((column) => column.accessorKey as string);

      // Chuyển đổi dữ liệu với tiêu đề cột mới và sắp xếp theo thứ tự cột
      const transformDataForExport = (data: any[]) => {
        return data.map((row) => {
          const transformedRow: any = {};
          columnOrder.forEach((key) => {
            if (columnHeaders[key]) {
              transformedRow[columnHeaders[key]] = row[key]; // Đổi tên cột theo header
            }
          });
          return transformedRow;
        });
      };

      const transformedData = transformDataForExport(dataExportExcel);

      // Tạo worksheet và workbook
      const worksheet = xlsx.utils.json_to_sheet(transformedData);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Data");

      // Ghi file Excel
      xlsx.writeFile(workbook, "lenh-san-xuat.xlsx");
      toast.success("Export excel thành công", { autoClose: 1500 });
    } catch (error) {
      console.error("Error exporting Excel:", error);
      toast.error("Export excel thất bại", { autoClose: 1500 });
    }
  };

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  const createOutward = (sourceCode: string | null) => {
    navigate("/warehouse-config/create-warehouse-out-ward", {
      state: {
        sourceCode: sourceCode,
        sourceType: "XUAT_DIEU_CHUYEN_LINH_KIEN_SAN_XUAT",
      },
    });
  };

  const createInward = (sourceCode: string | null) => {
    navigate("/warehouse-config/create-warehouse-in-ward", {
      state: {
        sourceCode: sourceCode,
        sourceType: "NHAP_THANH_PHAM_SAN_XUAT",
      },
    });
  };

  const createOutwarDaccessory = (sourceCode: string | null) => {
    if (!sourceCode) {
      return;
    }
    navigate("/warehouse-config/create-warehouse-out-ward", {
      state: {
        sourceCode: sourceCode,
        sourceType: "XUAT_LINH_KIEN_SAN_XUAT",
      },
    });
  };
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let queryParams = {
      Skip:
        firstRender && _searchJson
          ? _searchJson.Skip
          : pagination.pageIndex * pagination.pageSize,
      Take: firstRender && _searchJson ? _searchJson.Take : pagination.pageSize,
    } as any;

    try {
      const search = form.getValues();
      queryParams = {
        ...queryParams,
        // Skip: pagination.pageIndex * pagination.pageSize,
        // Take: pagination.pageSize,
        BranchId: search.BranchId?.toString(),
        FromDate: search.FromDate
          ? moment(search?.FromDate).format("M/D/YYYY")
          : "",
        ToDate: search.ToDate ? moment(search?.ToDate).format("M/D/YYYY") : "",
        KeySearch: search.keySearch?.toString(),
      };

      let url;

      url =
        "/api/v1/TblMfgProductOrder/get-list?" +
        Object.entries(queryParams)
          .filter(([, value]) => value !== undefined && value !== "")
          .map(
            ([key, value]) =>
              `${key}=${encodeURIComponent(value as string | number | boolean)}`,
          )
          .join("&");

      const response = await repositoryPos.get<MessageResponse<any>>(url);

      if (response && response.success) {
        const result = response.data || [];
        setData(result);

        if (result.length === 0) {
          setRowCount(0);
        } else {
          setRowCount(response.totalCount);
        }

        if (response.totalCount > pagination.pageSize) {
          const allParams = new URLSearchParams(url);
          allParams.set("Skip", "0"); // Đặt Skip = 0
          allParams.set("Take", response.totalCount.toString()); // Cập nhật Take = totalCount

          if (form.getValues().BranchId) {
            allParams.set("BranchId", form.getValues().BranchId.toString());
          }
          if (form.getValues().FromDate) {
            allParams.set(
              "FromDate",
              moment(form.getValues().FromDate).format("M/D/YYYY"),
            );
          }
          if (form.getValues().ToDate) {
            allParams.set(
              "ToDate",
              moment(form.getValues().ToDate).format("M/D/YYYY"),
            );
          }

          const allUrl = `/api/v1/TblMfgProductOrder/get-list?${allParams.toString()}`;
          const allResponse = await repositoryPos.get<MessageResponse<any>>(
            `${allUrl}`,
          );
          if (allResponse && allResponse.data && allResponse.success) {
            setDataExportExcel(allResponse.data); // Ghi đè dữ liệu với toàn bộ kết quả
          }
        } else {
          setDataExportExcel(result); // Ghi đè dữ liệu với toàn bộ kết quả
        }

        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setData([]);
        setRowCount(0);
      }
    } catch (error) {
      setIsError(true);
      setData([]);
      setRowCount(0);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(keySearchwip, JSON.stringify(queryParams));
    }
  };

  // Hàm gọi API chi nhánh
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch",
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };

  useEffect(() => {
    fetchDataBranch();
  }, []);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (200 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  useEffect(() => {
    if (isSmallScreen) {
      setColumnPinning(false); // Bỏ ghim cột khi thu nhỏ màn hình
    } else {
      setColumnPinning(true);
    }
  }, [isSmallScreen]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  const table = useMantineReactTable<ProductionOrder>({
    columns,
    data,
    enableColumnResizing: true,

    positionToolbarAlertBanner: "bottom",
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.id?.toString(),

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "maLsx", "id"],
        right: ["trangThai", "action"],
      },
      columnVisibility: { id: true },
    },
    enableRowSelection: false,
    mantineTableContainerProps: {
      style: { maxHeight: height + 50, minHeight: height + 50 },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
      sorting,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: columnPinning,
    mantineTableProps: {
      striped: false,
    },
  });

  useEffect(() => {
    if (pagination.pageIndex === 0 && data.length < pagination.pageSize) {
      fetchData();
    } else {
      fetchData();
    }
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "5px" }}
        ref={headerRef}
      >
        <Flex
          gap={0}
          justify={"space-between"}
          align="center"
          direction="row"
          wrap="wrap"
          w={"100%"}
        >
          <_breadcrumb></_breadcrumb>
          {/* <Flex gap="md" align="center" direction="row" wrap="wrap">
            <Menu shadow="md" width={200}>
              <Menu.Target>
                <Button
                  // size="xs"
                  rightSection={
                    <IconCaretDown
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Chức năng
                </Button>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Label>Application</Menu.Label>
                <Menu.Item
                  leftSection={
                    <IconFileExport
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  onClick={handleExport}
                >
                  Export Excel
                </Menu.Item>
                <Tooltip label={"Chức năng đang update"}>
                  <Menu.Item
                    leftSection={
                      <IconFileUpload
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                  >
                    Import Excel
                  </Menu.Item>
                </Tooltip>
              </Menu.Dropdown>
            </Menu>
          </Flex> */}
          <Button
            leftSection={<IconDownload size={14} />}
            color="violet"
            variant="outline"
            onClick={handleExport}
          >
            Xuất Excel
          </Button>
        </Flex>
        <Grid mt={10}>
          <GridCol span={sizeGrid}>
            {/* <Input
              w={"100%"}
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              onChange={(e) => {
                handleChangeSearchValue(e.target.value ?? "", "keySearch");
              }}
            /> */}
            <TextInput
              key={form.key("keySearch")}
              placeholder="Từ khoá"
              leftSection={<IconSearch color="#15aabf" />}
              {...form.getInputProps("keySearch")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </GridCol>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              type="default"
              key={form.key("FromDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...form.getInputProps("FromDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              key={form.key("ToDate")}
              leftSection={<IconTimeDuration15 color="#15aabf" />}
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              {...form.getInputProps("ToDate")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              key={dataBranch.length || form.key("BranchId")}
              searchable
              clearable
              placeholder="Chi nhánh"
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              data={dataBranch.map((item) => {
                return {
                  label: item.text,
                  value: item.value,
                };
              })}
              {...form.getInputProps("BranchId")}
            />
          </Grid.Col>
          <GridCol span={sizeGrid}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </GridCol>
        </Grid>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default MfgWip;
